import store from '@/store';

export default {
  inserted(el, binding) {
    const { value } = binding;
    const user = store.getters['app/currentUser'];
    const roles = user && user.permission_list;
    if (value && value instanceof Array && value.length > 0) {
      const permissionRoles = value;
      const hasPermission = roles.some(role => permissionRoles.includes(role));
      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el); // eslint-disable-line
      }
    } else {
      throw new Error('need roles! Like v-permission="[\'admin\',\'depot\']"');
    }
  },
};
